const PageHeader = ({ title, backURL, children }) => {
  return (
    <div className="meta-page-header--shared">
      <div className="header-left-content">
        <h1 className="page-title-with-back-arrow--component">
          <a href={backURL} className="back-arrow">
            <i className="far fa-chevron-left"></i>
          </a>
          <span className="title-text">{title}</span>
        </h1>
        <div className="page-primary-actions">{ children }</div>
      </div>
    </div>
  )
};

PageHeader.propTypes = {
  title:   PropTypes.string.isRequired,
  backURL: PropTypes.string.isRequired
};

export default PageHeader;



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/shared/components/PageHeader.js